import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {LinkContainer} from 'react-router-bootstrap';
import '../App.css'

function OffcanvasExample() {
  return (
    <>
      {[false].map((expand) => (
        <Navbar key={expand} expand={expand} className="mobile-canvas">
          <Container fluid>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav.Item  >
                <LinkContainer to="/fondant" className="nav__link">
                    <Nav.Link className="nav__link">Fondant Cakes</Nav.Link> 
                </LinkContainer>
                </Nav.Item>
                <Nav.Item  >
                <LinkContainer to="/icing">
                <Nav.Link className="nav__link">Icing Cakes</Nav.Link> 
                </LinkContainer>
                </Nav.Item>
                <Nav.Item>
                <LinkContainer to="/dessert">
                    <Nav.Link className="nav__link">Dessert Table</Nav.Link> 
                    </LinkContainer>
                </Nav.Item>
                <Nav.Item>
                <LinkContainer to="/prices">
                    <Nav.Link className="nav__link">Prices</Nav.Link> 
                    </LinkContainer>
                </Nav.Item>
                <Nav.Item>
                <LinkContainer to="/login">
                    <Nav.Link className="nav__link">Login</Nav.Link> 
                    </LinkContainer>
                </Nav.Item>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
}

export default OffcanvasExample;